"use client";

import { motion } from "motion/react";
import { Button } from "@/components/ui/button";
import { Book, School, Home } from "lucide-react";
import Link from "next/link";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-br from-blue-50 to-gray-100 p-6">
      {/* Animated School Icon */}
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <School className="w-24 h-24 text-primary" />
      </motion.div>

      {/* Text Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-center mt-4"
      >
        <h1 className="text-4xl font-bold text-gray-900">
          Oops! Page Not Found
        </h1>
        <p className="text-gray-600 mt-2 text-lg">
          Looks like you&apos;re lost in the school hallways! 🏫
        </p>
      </motion.div>

      {/* Floating Books Animation */}
      <motion.div
        initial={{ rotate: -10, y: 10 }}
        animate={{ rotate: 10, y: -10 }}
        transition={{
          repeat: Infinity,
          duration: 2,
          ease: "easeInOut",
          repeatType: "reverse",
        }}
        className="absolute left-20 top-1/3"
      >
        <Book className="w-10 h-10 text-primary" />
      </motion.div>

      <motion.div
        initial={{ rotate: 10, y: -10 }}
        animate={{ rotate: -10, y: 10 }}
        transition={{
          repeat: Infinity,
          duration: 2,
          ease: "easeInOut",
          repeatType: "reverse",
        }}
        className="absolute right-20 top-1/2"
      >
        <Book className="w-10 h-10 text-accent" />
      </motion.div>

      {/* Back to Home Button */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="mt-6"
      >
        <Link href="/">
          <Button className="px-6 py-3 text-lg flex items-center gap-2">
            <Home className="w-5 h-5" />
            Go Back Home
          </Button>
        </Link>
      </motion.div>
    </div>
  );
}
